export const LEAD_CAPTURE_TOPICS_V1_MODAL_ID = "lead-capture-topics";
export const LEAD_CAPTURE_PROGRAMS_V1_MODAL_ID = "lead-capture-programs";
export const LEAD_CAPTURE_UPCOMING_COURSE_V1_MODAL_ID =
  "lead-capture-upcoming-course";
export const LEAD_CAPTURE_UPCOMING_COURSE_V2_MODAL_ID =
  "lead-capture-upcoming-course";
